// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mdb-wysiwyg-container[data-v-29784248] {\n  display: block;\n  border: 1px solid #ededed;\n  border-radius: 3px 3px 0 0;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
